export const AssistantActionConst = {
  FETCH_REQUEST: "ASSISTANT_FETCH_REQUEST",
  FETCH_SUCCESS: "ASSISTANT_FETCH_SUCCESS",
  FETCH_FAIL: "ASSISTANT_FETCH_FAIL",

  CREATE_REQUEST: "ASSISTANT_CREATE_REQUEST",
  CREATE_SUCCESS: "ASSISTANT_CREATE_SUCCESS",
  CREATE_FAIL: "ASSISTANT_CREATE_FAIL",

  UPDATE_REQUEST: "ASSISTANT_UPDATE_REQUEST",
  UPDATE_SUCCESS: "ASSISTANT_UPDATE_SUCCESS",
  UPDATE_FAIL: "ASSISTANT_UPDATE_FAIL",

  DELETE_REQUEST: "ASSISTANT_DELETE_REQUEST",
  DELETE_SUCCESS: "ASSISTANT_DELETE_SUCCESS",
  DELETE_FAIL: "ASSISTANT_DELETE_FAIL",

  CLEAR_STATUS: "ASSISTANT_CLEAR_STATUS",
};
